
import Vue from 'vue'
import { Component } from 'vue-property-decorator'
import ConfigModule from '@/store/modules/config-module'

@Component
export default class Footer extends Vue {
  public get appVersion (): string {
    return ConfigModule.appVersion
  }

  public get linkToConfluence (): string {
    return ConfigModule.linkToConfluence
  }
}
